// The parts of Google Identity Services that the sign-in button uses.
export type GoogleIdentity = {
  accounts: {
    id: {
      initialize(_options: {
        client_id: string;
        callback: (_response: { credential: string }) => void;
        auto_select?: boolean;
        cancel_on_tap_outside?: boolean;
      }): void;
      renderButton(_parent: HTMLElement, _options: Record<string, unknown>): void;
    };
  };
};

const GOOGLE_SCRIPT_URL = "https://accounts.google.com/gsi/client";

let googleScriptPromise: Promise<GoogleIdentity> | undefined;

export function loadGoogleIdentity(locale = "en"): Promise<GoogleIdentity> {
  const loaded = window.google;
  if (loaded?.accounts?.id) return Promise.resolve(loaded);
  if (googleScriptPromise) return googleScriptPromise;

  googleScriptPromise = new Promise<GoogleIdentity>((resolve, reject) => {
    const existing = document.querySelector<HTMLScriptElement>("script[data-google-identity]");
    const script = existing || document.createElement("script");
    script.addEventListener("load", () => resolve(window.google!), { once: true });
    script.addEventListener("error", () => reject(new Error("google-script-unavailable")), {
      once: true,
    });
    if (!existing) {
      script.src = `${GOOGLE_SCRIPT_URL}?hl=${encodeURIComponent(locale)}`;
      script.dataset.googleIdentity = "true";
      script.async = true;
      document.head.append(script);
    }
  });

  return googleScriptPromise;
}
